
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getNotesAndCommentsForRegion",
      resolverType: "query",
      routePath: "/getNotesAndCommentsForRegion",
      httpMethod: "POST",
    });
  